<template>
    <div id="app">
        <router-view></router-view>
    
    </div>
  
</template>

<script>

export default {
  name: 'app',
  data: function () {
    return {
      isMobile: false,
      transitionName:''
    }
  },
    watch: {
      // 使用watch 监听$router的变化
      $route (to, from) {
        if(from.path == '/pcpage/mainpage/home'){
            this.transitionName = 'slide-left';
        }

    }
    },
  methods: {
    // 检查是否是移动端
    checkIsMobile () {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
	    if(flag) {
        this.replacePcUrl()
        this.setHtmlFontSize()
      }else {
        this.replaceMobileUrl()
      }

    },
    setHtmlFontSize () {
      //得到手机屏幕的宽度
      let htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
      //得到html的Dom元素
      let htmlDom = document.getElementsByTagName('html')[0];
      //设置根元素字体大小
      htmlDom.style.fontSize = htmlWidth / 7.5 + 'px';

    },
    replacePcUrl () {
      var path = this.$route.path
      var toUrl = '/m_page/m_mainpage'
      switch (path) {
        case '/pcpage/mainpage/home':
          toUrl = '/m_page/m_mainpage'
          break;
        case '/pcpage/mainpage/news':
          toUrl = '/m_page/m_mainpage'
          break;
        case '/pcpage/mainpage/timeline':
          toUrl = '/m_page/m_mainpage'
          break;
        case '/pcpage/mainpage/awards':
          toUrl = '/m_page/m_mainpage'
          break;
        case '/pcpage/mainpage/speakers':
          toUrl = '/m_page/m_mainpage'
          break;
        case '/pcpage/mainpage/picture':
          toUrl = '/m_page/m_mainpage'
          break;
        case '/pcpage/mainpage/resource':
          toUrl = '/m_page/m_mainpage'
          break;
        case '/pcpage/mainpage/history':
          toUrl = '/m_page/m_mainpage'
          break;
        case '/pcpage/detailpage/newsdetail':
          toUrl = '/m_page/m_detailpage/m_newsdetail'
          break;
        default:
          toUrl = path
          break;
      }
      this.$router.replace({
        path: toUrl,
        query: this.$route.query
      })
    },
    replaceMobileUrl () {
      var path = this.$route.path
      var toUrl = '/pcpage/mainpage/home'
      switch (path) {
        case '/m_page/m_mainpage':
          toUrl = '/pcpage/mainpage/home'
          break;
        default:
          toUrl = path
          break;
      }
      this.$router.replace({
        path: toUrl,
        query: this.$route.query
      })
    },
  },
  mounted: function () {
    this.checkIsMobile()
  }
}
</script>

<style>
html,body {
  width: 100%;
  height: 100%;
}
body {
  font-size: 18px;
}
#app {
  width: 100%;
  height: 100%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.clearfix:after {
  display: block;
  clear: both;
  content: "";
  visibility: hidden;
  height: 0;

}
/* element弹出框修改样式 */
.el-popup-parent--hidden {
    overflow-y: auto !important;
}
@media (min-width: 1024px){
html{font-size: 16px}
} /*>=1024的设备*/

@media (min-width: 1100px) {
html{font-size: 18px}
} /*>=1100的设备*/
@media (min-width: 1280px) {
html{font-size: 20px;}
} /*>=1280的设备*/

@media (min-width: 1366px) {

html{font-size: 22px;}
}  

@media (min-width: 1440px) {
html{font-size: 24px;}
} 

@media (min-width: 1680px) {
html{font-size: 28px;}
} 
@media (min-width: 1920px) {
html{font-size: 33px;}
} 


</style>
